import React from 'react'
import RouteConstant from 'constants/RouteConstant'
import CommonLayout from 'layouts/Common'
import {Redirect, Route, Switch} from 'react-router-dom'
import RouteIf from 'routes/RouteIf'

import LicenseAnalysisOrganizationList from 'pages/LicenseAnalysisOrganization/LicenseAnalysisOrganizationList'
import {AllUserRoles} from 'Authority'

export default function LicenseAnalysisOrganizationRoute() {
  return (
    <CommonLayout>
      <Switch>
        <RouteIf
          requiredRoles={AllUserRoles}
          path={RouteConstant.LICENSE_ANALYSIS_ORGANIZATION.path}
          exact
          component={LicenseAnalysisOrganizationList}
        />

        <Route path='*'>
          <Redirect to={RouteConstant.ERROR_NOT_FOUND.path} />
        </Route>
      </Switch>
    </CommonLayout>
  )
}
